import { isString } from 'lodash-es'

export const normalizeUrl = (_value) => {
  if (!isString(_value)) {
    return _value
  }

  const value = _value.trim()

  if (value.match(/^https?:\/\//)) {
    return value
  }

  return `https://${value}`
}
